// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2F8ub","content":"styles_content__EMkz-","checkbox":"styles_checkbox__1Zqy5","checkboxLabel":"styles_checkboxLabel__3tJD2"};